import { Component } from 'react';
import { NSARouterMakerProps } from 'namirasoft-account-react';
import { NWSRegionRouterProps } from '../NWSRegionRouterProps';
import { NWSRegionLayout } from '../NWSRegionLayout';
import { NWSRegionEntities } from '../NWSRegionEntities';

export interface RegionListPageProps extends NSARouterMakerProps, NWSRegionRouterProps { }

class RegionListPage extends Component<RegionListPageProps>
{
    override render()
    {
        return (
            <NWSRegionLayout
                {...this.props}
                pages={{
                    entity: NWSRegionEntities.region(this.props),
                    list: {}
                }}
            >
                <></>
            </NWSRegionLayout>
        );
    }
}

export default RegionListPage;